import React, { Component } from 'react'
import Navbar from '../../Components/Navbar'
import Footer from '../../Components/Footer'
import { connect } from 'react-redux'
import './home.css'
import CookieConsentComponent from '../../Components/CookieConsent'
import { fetchUserInfo } from '../../redux-flow/actions/users'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import cup from '../../images/cup.svg'
import bars from '../../images/chart.svg'
import chart from '../../images/graph.svg'
import { Link } from 'react-router-dom'
import CardFlwt from '../../Components/CardFlwt'
import Banner from './banner'
import arrow from '../../images/programming-arrow.svg'
import receiptSearch from '../../images/receipt-search.svg'
import moneys from '../../images/moneys.svg'
import theme from '../../config/theme'

const secondItems = [
    {
        icon: cup,
        text: 'Automação inteligente para maximizar seus investimentos Nossa IA opera estrategicamente em criptoativos, buscando oportunidades 24/7 para otimizar seus lucros com segurança e eficiência.'
    },
    {
        icon: bars,
        text: 'Ganhe renda passiva com segurança e inovação Participe de um ecossistema de investimentos sustentável, onde sua participação gera retornos constantes sem complicações.'
    },
    {
        icon: chart,
        text: 'Tecnologia e transparência para seu crescimento financeiro Nossa plataforma combina inteligência artificial e um sistema de afiliados para potencializar ganhos e garantir a proteção do seu capital.'
    },
]

const items3 = [
    {
        icon: arrow,
        text: "Maximize seus ganhos com locação de criptoativos Coloque seus criptoativos para trabalhar e gere renda passiva enquanto mantém a posse total de seus ativos, sem precisar vendê-los."
    },
    {
        icon: receiptSearch,
        text: "Segurança e transparência em cada transação Com contratos inteligentes e monitoramento contínuo, garantimos operações seguras e eficientes, protegendo seu patrimônio contra volatilidade extrema."
    },
    {
        icon: moneys,
        text: "Alta liquidez e flexibilidade para seu capital Alugue seus ativos para traders e instituições qualificadas, aproveitando retornos previsíveis e sem a necessidade de gestão ativa."
    },
]
class Home extends Component {
    constructor(props) {
        super (props)
        this.state = {
            fillBackground: false,
            whitelabel: process.env.REACT_APP_NAME
        }
    }

    componentDidMount = async () => {
        const { onLoad, userid, logged } = this.props
        if(logged && onLoad && userid) {
            onLoad(userid)
        }
        window.scrollTo(0,0);
        window.addEventListener('scroll', this.handleWindowScroll, true)
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleWindowScroll, true)
    }

    handleWindowScroll = () => {
        this.setState({
            fillBackground: window.scrollY > 100
        })
    }

    render() {
        return (
            <div
                id="sectionHome"
                style={{ backgroundColor: theme.colors.secondary }}
            >
                <script
                    dangerouslySetInnerHTML={{
                        __html: `
                        (function(c,l,a,r,i,t,y){
                            c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
                            t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
                            y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
                        })(window, document, "clarity", "script", "d0x20zgklq");`,
                    }}
                />;
                <Navbar fillBackground={this.state.fillBackground} />
                <Banner />
                <div className="section">
                    <Container>
                        <Row>
                            <Col md={12} className="d-flex flex-column ">
                                <h2
                                    className="subtitlePages text-white textDefi"
                                    style={{
                                        fontFamily: theme.typography.fontFamily.bold,
                                        fontSize: theme.typography.fontSize.xlarge,
                                        color: theme.colors.white
                                    }}
                                >
                                   A inovação que você precisa para atingir os seus objetivos financeiros
                                </h2>
                                <Row className="mt-5 rowDefiHome">
                                    {secondItems.map((item, index) => (
                                        <Col md={4} key={index} className='colDefiHome'>
                                            <div className="wrapperItemWallet">
                                                <img src={item.icon} alt={item.text} />
                                                <p
                                                    style={{
                                                        fontFamily: theme.typography.fontFamily.primary,
                                                        fontSize: theme.typography.fontSize.medium,
                                                        color: theme.colors.white
                                                    }}
                                                >
                                                    {item.text}
                                                </p>
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                                <div className="d-flex mt-5 align-items-center justify-content-center buttonsDefiWrapper">
                                    <Link
                                        to="/cadastro"
                                        className="anchorBtn"
                                        style={{
                                            backgroundColor: theme.colors.primary,
                                            color: theme.colors.white,
                                            borderColor: theme.colors.primary,
                                            fontFamily: theme.typography.fontFamily.bold,
                                            fontSize: theme.typography.fontSize.medium,
                                        }}
                                    >
                                        INVESTIR AGORA
                                    </Link>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
                    
                <div className="section mt-5 sectionEducation">
                    <Container>
                        <Row>
                            <Col md={12} className="d-flex justify-content-center">
                                <h2 className="text-white subtitlePages">Dominando o futuro financeiro e revolucionando como você investe com segurança e alta performance.                                </h2>
                            </Col>
                            {items3.map(item => (
                                <Col md={4} className="d-flex justify-content-center mt-5 mb-0">
                                    <div className="wrapperItemWallet">
                                        <img src={item.icon} alt={item.text} />
                                        <p>{item.text}</p>
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </Container>
                </div>
                <CookieConsentComponent />
                <Footer />
            </div>
        )
    }
}

const mapStateToProps = state => ({
    logged: state.login.logged,
    userid: state.login.userid,
    userLogged: state.users.userLogged,
})

const mapDispatchToProps = dispatch => ({
    onLoad: id => {
        dispatch(fetchUserInfo(id))
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(Home)